import { ICreditLinesFilters } from "../models/credit-lines-filters.model";
import { ICreditRequestFilters } from "../models/credit-request-filters.model";
import { IFinancingNegotiation, IFinancingNegotiationsFilters, IFinancingQuestion, IFinancingQuestionsFilters } from "../models/financing-negotiations.model";
import { ICreditOffersFilters } from "../models/offers-filters.model";

export class GetMyPublicProfileAction {
  static readonly type = "[Financing] GetMyPublicProfileAction";
  constructor() {}
}

export class SearchCreditLinesListAction {
  static readonly type = "[Financing] SearchCreditLinesListAction";
  constructor(public payload: { filter: ICreditLinesFilters }) {}
}

export class SearchCreditOffersListAction {
  static readonly type = "[Financing] SearchCreditOffersListAction";
  constructor(public payload: { filter: ICreditOffersFilters }) {}
}

export class SearchCreditRequestsListAction {
  static readonly type = "[Financing] SearchCreditRequestsListAction";
  constructor(public payload: { filter: ICreditRequestFilters }) {}
}

export class SearchFinancingNegotiationsListAction {
  static readonly type = "[Financing] SearchFinancingNegotiationsListAction";
  constructor(public payload: { filter: IFinancingNegotiationsFilters }) {}
}

export class SearchFinancingQuestionsListAction {
  static readonly type = "[Financing] SearchFinancingQuestionsListAction";
  constructor(public payload: { filter: IFinancingQuestionsFilters }) {}
}

export class UpdateFinancingQuestionAction {
  static readonly type = "[Financing] UpdateFinancingQuestionAction";
  constructor(public payload: { question: IFinancingQuestion }) {}
}

export class ClearFinancingNegotiationsListAction {
   static readonly type = "[Financing] ClearFinancingNegotiationsListAction";
   constructor() {}
}

export class GetRequestStatusOptionsAction {
   static readonly type = "[Financing] GetRequestStatusOptionsAction";
   constructor() {}
}

export class UpdateNegotiationInListAction {
  static readonly type = "[Financing] UpdateNegotiationInListAction";
  constructor(public payload: { negotiation: IFinancingNegotiation }) {}
}

export class RefreshNegotiationInListAction {
  static readonly type = "[Financing] RefreshNegotiationInListAction";
  constructor(public payload: { negotiation: IFinancingNegotiation }) {}
}